import { SERVER_URL as serverURL } from './config';
const ipfsURL = process.env.REACT_APP_IPFS_GATEWAY;
const server3dnTechURL = process.env.REACT_APP_3DNTECH_SERVER

// preservation-allow — retraits intentionnels (openseaApi + entrées mock) archivés, cf. ci-dessous.
// Vague 4 lot 3 (audit P1-8 pattern 3) — ce module n'est PLUS un catalogue d'endpoints :
// les entrées mock (/nfts.json, /nft_showcases.json, /authors.json, /author_ranks.json,
// /hot-collections.json, /contact-forms, /blog-posts*) et l'export openseaApi (testnets)
// n'étaient consommés QUE par les thunks legacy morts (fetchNftShowcase, blogs.js,
// hotCollections.js, fetchAuthorRanking, postContactForm) et Opensea/Card — tous archivés
// dans src/_archive/2026-07-04-vague4-http/. Il ne reste que la config d'URLs réelles,
// consommée par ~17 fichiers vivants (imageUrl.js, fiches détail, SupportPortal…).
const api = {
    baseUrl: serverURL,
    server3dnTech: server3dnTechURL,
    ipfsURL: ipfsURL,
}

export default api;
